
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrendDown as ObiTrendDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-trend-down.js';
 
 
 

 
 export const ObiTrendDown = createComponent({
   react: React,
   tagName: 'obi-trend-down',
   elementClass: ObiTrendDownElement,
   events: {
     
   }
  });
 
 